const b2bNote = document.getElementById("b2b_note");
const name = document.getElementById("CartName");
const email = document.getElementById("CartEmail");
const instruction = document.getElementById("CartSpecial");
const note = document.getElementById("CartNote");
const license = document.getElementById("CartLicenseId");
var scRequiredText = document.getElementById("scRequiredText");
var checkoutBtn = document.getElementById("checkout");

//Check saved cart note
getCartNotes();

//Update notes when checkout
if(checkoutBtn != null) {
  checkoutBtn.addEventListener("click", updateCartNotes);
}
if(name != null) {
  name.addEventListener("input", attrChange);
}
if(b2bNote != null) {
  b2bNote.addEventListener("input", attrChange);
}
if(email != null) {
  email.addEventListener("input", attrChange);
}
if(instruction != null) {
  instruction.addEventListener("input", attrChange);
}
if(note != null) {
  note.addEventListener("input", attrChange);
}
if(license != null) {
  license.addEventListener("input", attrChange);
}
function attrChange(e) {
  let b2bNoteValue = ``;
  let licenseValue = ``;
  let nameValue = name.value;
  let emailValue = email.value;
  let instructionValue = instruction.value;
  let noteValue = note.value.replace("\n"," ");
  if(b2bNote != null && b2bNote.value) {
    b2bNoteValue = b2bNote.value.replace("\n"," ");
  }
  if(license != null && license.value) {
    licenseValue = license.value;
  }

  let finalNotes = ``;

  if(b2bNote != null) {
    finalNotes = `License ID: ${licenseValue}\r\nB2B Note: ${b2bNoteValue}\r\nName: ${nameValue}\r\nEmail: ${emailValue}\r\nSpecial Instructions: ${instructionValue}\r\nNote: ${noteValue}`;
  } else {
    finalNotes = `License ID: ${licenseValue}\r\nName: ${nameValue}\r\nEmail: ${emailValue}\r\nSpecial Instructions: ${instructionValue}\r\nNote: ${noteValue}`;
  }
  document.getElementById("bss-cart-note-textarea").value = finalNotes;
  scRequiredText = document.getElementById("scRequiredText");
  if(scRequiredText != null) {
    if(licenseValue) {
      if(validateLicense(licenseValue)) {
        scRequiredText.style.display = "none";
        checkoutBtn.disabled = false;
      } else {
        scRequiredText.style.display = "block";
        checkoutBtn.disabled = true;
      }
    } else {
      scRequiredText.style.display = "block";
      checkoutBtn.disabled = true;
    }
  }
}

function validateLicense(license) {
  if(!license.trim()) {
    return false;
  }
  return true
}

function updateCartNotes() {
  let bssCartNotes = document.getElementById("bss-cart-note-textarea");
  if(bssCartNotes != null) {
    let notes = bssCartNotes.value;
    fetch(window.Shopify.routes.root + 'cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ note: notes })
    });
  }
}

function getCartNotes() {
  fetch(window.Shopify.routes.root + 'cart.js', {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json'
    }
  }).then(response => {
    return response.json();
  }).then(responseJsonCart => {
    console.log(responseJsonCart);
    if(responseJsonCart.note) {
      let bssCartNotes = document.getElementById("bss-cart-note-textarea");
      bssCartNotes.value = responseJsonCart.note;
      let noteArr = responseJsonCart.note.split("\n");
      console.log(noteArr);
      for(let i=0; i<noteArr.length; i++) {
        if(noteArr[i].startsWith("License ID: ")) {
          if(license != null) {
            license.value = noteArr[i].replace("License ID: ","");
              
            var event = new Event('input');
            license.dispatchEvent(event);
          }
        }
        if(noteArr[i].startsWith("B2B Note: ")) {
          if(b2bNote != null) {
            b2bNote.value = noteArr[i].replace("B2B Note: ","");
              
            var event = new Event('input');
            b2bNote.dispatchEvent(event);
          }
        }
        if(noteArr[i].startsWith("Name: ")) {
          if(name != null) {
            name.value = noteArr[i].replace("Name: ","");
              
            var event = new Event('input');
            name.dispatchEvent(event);
          }
        }
        if(noteArr[i].startsWith("Email: ")) {
          if(email != null) {
            email.value = noteArr[i].replace("Email: ","");
              
            var event = new Event('input');
            email.dispatchEvent(event);
          }
        }
        if(noteArr[i].startsWith("Special Instructions: ")) {
          if(instruction != null) {
            instruction.value = noteArr[i].replace("Special Instructions: ","");
              
            var event = new Event('input');
            instruction.dispatchEvent(event);
          }
        }
        if(noteArr[i].startsWith("Note: ")) {
          if(note != null) {
            note.value = noteArr[i].replace("Note: ","");
              
            var event = new Event('input');
            note.dispatchEvent(event);
          }
        }
      }
    }
  });
}


// const createLicenseElem = document.getElementById("PolarisCheckbox2");
// if(createLicenseElem != null) {
//   createLicenseElem.checked = true;
  
//   //Empty all input
//   let area1 = document.querySelectorAll("#shopify-section-template--16406488907821__17131918369b0fb3c9 textarea");
//   if(area1.length > 0) {
//     for(let i=0; i<area1.length;i++) {
//       area1[i].value = "";
//     }
//   }
//   let area2 = document.querySelectorAll("#shopify-section-template--16406488907821__1713233061242b4510 textarea");
//   if(area2.length > 0) {
//     for(let i=0; i<area2.length;i++) {
//       area2[i].value = "";
//     }
//   }
//   document.querySelector("#shopify-section-template--16406488907821__17131918369b0fb3c9").style.display = "none";
//   document.querySelector("#shopify-section-template--16406488907821__1713233061242b4510").style.display = "block";
  
  
//   createLicenseElem.addEventListener("change", function(e) {
//     if(e.target.checked) {
//       document.querySelector("#shopify-section-template--16406488907821__17131918369b0fb3c9").style.display = "none";
//       document.querySelector("#shopify-section-template--16406488907821__1713233061242b4510").style.display = "block";
//     } else {
//       document.querySelector("#shopify-section-template--16406488907821__17131918369b0fb3c9").style.display = "block";
//       document.querySelector("#shopify-section-template--16406488907821__1713233061242b4510").style.display = "none";
//     }
//   });
// }